import { useEffect } from "react";
import { SITE_URL } from "../../seo/business";

const DEFAULT_TITLE = "Dentist in Bensonhurst, Brooklyn | Benson Dental Studio";
const DEFAULT_IMAGE = `${SITE_URL}/og-image.jpg`;

const setMeta = (selector, attr, key, content) => {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    tag.setAttribute(attr, key);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", content);
};

const SEO = ({ title, fullTitle, description, canonical, image, noindex, jsonLd }) => {
  const jsonLdString = jsonLd ? JSON.stringify(jsonLd) : "";

  useEffect(() => {
    const pageTitle = fullTitle || (title ? `${title} | Benson Dental Studio` : DEFAULT_TITLE);
    const imageUrl = image ? `${SITE_URL}${image}` : DEFAULT_IMAGE;

    document.title = pageTitle;
    setMeta('meta[property="og:title"]', "property", "og:title", pageTitle);
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", pageTitle);
    setMeta('meta[property="og:image"]', "property", "og:image", imageUrl);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", imageUrl);

    if (description) {
      setMeta('meta[name="description"]', "name", "description", description);
      setMeta('meta[property="og:description"]', "property", "og:description", description);
      setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    }

    if (canonical) {
      let canonicalLink = document.head.querySelector('link[rel="canonical"]');
      if (!canonicalLink) {
        canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalLink);
      }
      canonicalLink.setAttribute("href", `${SITE_URL}${canonical}`);
      setMeta('meta[property="og:url"]', "property", "og:url", `${SITE_URL}${canonical}`);
    }

    const robots = document.head.querySelector('meta[name="robots"]');
    if (noindex) {
      setMeta('meta[name="robots"]', "name", "robots", "noindex, follow");
    } else if (robots) {
      robots.remove();
    }

    // Page-specific structured data. The sitewide Dentist entity lives
    // statically in public/index.html; these reference it by @id.
    document.head.querySelectorAll("script[data-seo]").forEach((s) => s.remove());
    if (jsonLdString) {
      JSON.parse(jsonLdString).forEach((data) => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.setAttribute("data-seo", "");
        script.textContent = JSON.stringify(data);
        document.head.appendChild(script);
      });
    }
  }, [title, fullTitle, description, canonical, image, noindex, jsonLdString]);

  return null;
};

export default SEO;
